import React, { useEffect, useState } from "react";
import  { useNavigate, Navigate } from 'react-router-dom'
import { baseUrl } from "../shared";
import '../pages/App.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Toggle } from './ui';

export function Register({ onClose }) {
    // Close the modal: caller's handler (overlay) or fall back to reloading /admin.
    const close = onClose || (() => { window.location.href = '/admin'; });
    const [usernameReg, setUsernameReg] = useState("");
    const [passwordReg, setPasswordReg] = useState ("");
    const [companyReg, setCompanyReg] = useState ("");
    const [fullNameReg, setFullNameReg] = useState ("");
    const [emailAddressReg, setEmailAddressReg] = useState ("");
    const [canAdminFunctions, setCanAdminFunctions] = useState("0");
    const [canViewWallboard, setCanViewWallboard] = useState("0");
    const navigate = useNavigate();

    const [loginStatus, setLoginStatus] = useState(false);
    const [createNewUser] = useState(true);
    const [open, setOpen] = React.useState(false);
    const [errOpen, setErrOpen] = React.useState(false);
    const [message, setMessage] = useState('');

    const handleClose = () => {
      setOpen(false);
      <Navigate to={'/admin/'} />
      {navigate(0)}
    };

    const handleErrClose = () => {
      setErrOpen(false);
    };

    useEffect(()=> {
      if (!localStorage.getItem('token')) {
        setLoginStatus(false);
      } else {
        setLoginStatus(true);
      }
    },[]);


  const sendCreateUser = async () => {
    const url = baseUrl+"user/register";
    var payload = {
      "username": usernameReg,
      "password": passwordReg,
      "fullName": fullNameReg,
      "company": companyReg,
      "emailAddress": emailAddressReg,
      "active": "1",
      "adminFunctions": canAdminFunctions,
      "canViewWallboard": canViewWallboard,
    }
    await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        },
        body: ( "json", JSON.stringify( payload ) )
      })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data.status === 200) {
          setMessage(data.message);
          setOpen(true);
          } else if (data.status === 401) {
            setMessage(data.message);
            setErrOpen(true);
          }
        })
        .catch((err) => {
          setMessage(err.message);
          setOpen(true);
        });
};


    return (
      <div className="admin">
        <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="confirmDeleteTitle">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmDeleteDesc">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        <React.Fragment>
      <Dialog
        open={errOpen}
        onClose={handleErrClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="addAccountError">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="addAccountDesc">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleErrClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>


    { loginStatus && createNewUser && localStorage.getItem('adminFunctions') === '1' ? (
        <Dialog open onClose={close} fullWidth maxWidth="sm">
          <DialogTitle>Register New User</DialogTitle>
          <DialogContent dividers>
        <Box>
         <TextField
        fullWidth
        required
          margin="dense"
          id="username"
          label="Username"
          variant="outlined"
          type="text"
          onChange={(e) => {
            setUsernameReg(e.target.value);
          }}
        />
     </Box>
        <Box>
         <TextField
        fullWidth
        required
          margin="dense"
          id="password"
          label="Password"
          variant="outlined"
          type="password"
          onChange={(e) => {
            setPasswordReg(e.target.value);
          }}
        />
     </Box>
        <Box>
          <TextField
          fullWidth
          required
          label="Company"
          variant="outlined"
          type="text"
          onChange={(e) => {
            setCompanyReg(e.target.value);
          }}
          />
            </Box>
        <Box>
         <TextField
        fullWidth
        required
          margin="dense"
          id="name"
          label="Full Name"
          variant="outlined"
          type="text"
          onChange={(e) => {
            setFullNameReg(e.target.value);
          }}
        />
     </Box>
        <Box>
         <TextField
        fullWidth
        required
          margin="dense"
          id="email"
          label="E-Mail Address"
          variant="outlined"
          type="text"
          onChange={(e) => {
            setEmailAddressReg(e.target.value);
          }}
        />
     </Box>
     <Box sx={{ width: '100%', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', overflow: 'hidden', mt: 1, mb: 1 }}>
       {[
         { label: 'Can Use Admin Functions', checked: canAdminFunctions === "1", setter: setCanAdminFunctions },
         { label: 'Can View Wallboard',      checked: canViewWallboard === "1",   setter: setCanViewWallboard },
       ].map(({ label, checked, setter }, i, arr) => (
         <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1, backgroundColor: i % 2 === 0 ? 'var(--surface-2)' : 'var(--surface)', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
           <Box component="span" sx={{ fontSize: '0.875rem', color: 'var(--text)', flex: 1 }}>{label}</Box>
           <Toggle checked={checked} onChange={() => setter(checked ? "0" : "1")} />
         </Box>
       ))}
     </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={close}>Cancel</Button>
            <Button variant="contained" onClick={sendCreateUser}>Register</Button>
          </DialogActions>
        </Dialog>
        ) : null
      }
      </div>
    );
  }

export default Register
